<template>
  <div class="third yszc">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">APP使用协议配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="ruleFormFN()"
                     class="btn-two"
                     type="default">重置</el-button>
          <el-button @click="saveFN()"
                     class="btn-two"
                     type="primary"
                     v-el-disabel-repeat-click>保存</el-button>
        </div>
      </div>
      <el-form :show-message="false"
               style="width:1100px;float:left"
               label-width="86px">
        <div class="formOne-forms">
          <div class="forms-one"
               style="margin-top: 57px;">
            <div class="one-list">
              <el-form :model="valueDate"
                       :rules="rules"
                       ref="valueDate"
                       label-width="86px">
                <div class="list-two-line">
                  <el-form-item label="APP使用协议"
                                prop="appUseAgreement"
                                class="sensitiveConfiguration-text-area">
                    <wangEditor @getContent='getContent1'
                                height='150px'
                                :excludeKeys='excludeKeys'
                                :maxLength='200'
                                editorId='appSYXX'
                                ref="wangEditor1"> </wangEditor>
                  </el-form-item>
                </div>
                <div class="list-two-line">
                  <el-form-item label="隐私政策"
                                prop="content"
                                class="sensitiveConfiguration-text-area">
                    <el-button style="height: 24px"
                               type="default"
                               icon="el-icon-document-copy"
                               @click="copy(1)">复制隐私政策链接</el-button>
                    <wangEditor @getContent='getContent2'
                                height='300px'
                                :excludeKeys='excludeKeys'
                                :maxLength='10000'
                                editorId='YSZC'
                                ref="wangEditor2"> </wangEditor>
                  </el-form-item>
                </div>
                <div class="list-two-line">
                  <el-form-item label="用户协议"
                                prop="userAgreement"
                                class="sensitiveConfiguration-text-area">
                    <el-button style="height: 24px"
                               type="default"
                               icon="el-icon-document-copy"
                               @click="copy(2)">复制用户协议链接</el-button>
                    <wangEditor @getContent='getContent3'
                                height='300px'
                                :excludeKeys='excludeKeys'
                                :maxLength='10000'
                                editorId='YHXX'
                                ref="wangEditor3"> </wangEditor>
                  </el-form-item>
                </div>
                <div class="list-two-line">
                  <el-form-item label="温馨提示"
                                prop="reminder"
                                class="sensitiveConfiguration-text-area">
                    <wangEditor @getContent='getContent4'
                                height='150px'
                                :maxLength='200'
                                :excludeKeys='excludeKeys'
                                editorId='WXTS'
                                ref="wangEditor4"> </wangEditor>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <notice-modal :noticeModalVisible="noticeModal"
                    @noticeModalClose="closeNotice"
                    @noticeModalAgree="agreeNotice"
                    btnclose='仅保存'
                    noticeTitle="提示"
                    :noticeType="1"
                    btnAgree="需要重新阅读并同意"
                    noticeContent="保存后是否需要用户重新阅读并同意">
      </notice-modal>
      <!-- <div style="    width: 60%;
    height: 60%;
    float: left;
    font-size: 14px;" v-html="valueDate.value">
      </div> -->
      <!-- <div class="sensitive-phon-right">
        <div class="phon-right-img"  v-html="valueDate.value">
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import wangEditor from 'wangeditor'
import request from '@/utils/request'
import wangEditor from "@/views/APP-SERVICE-SETTING/wangEditor/index.vue"
export default {
  name: "formSeven",
  components: {
    // addOfficalAccounts
    wangEditor,
  },
  data () {
    return {
      excludeKeys: ['insertVideo', 'uploadVideo', 'group-video', "fullScreen"],
      countNum: 1,
      rules: {
        appUseAgreement: [
          {
            required: true,
            message: `请输入`,
            trigger: 'blur'
          },
        ],
        userAgreement: [
          {
            required: true,
            message: `请输入`,
            trigger: 'blur'
          },
        ],
        content: [
          {
            required: true,
            message: `请输入`,
            trigger: 'blur'
          },
        ],
        reminder: [
          {
            required: true,
            message: `请输入`,
            trigger: 'blur'
          },
        ]
      },

      //---------------------------------------

      valueDate: {
        isAgainRead: 2,
        version: '',
        appUseAgreement: '',//app使用协议
        appUseAgreementStr: '',
        userAgreement: '',//用户协议
        userAgreementStr: '',
        content: '',
        contentStr: '',
        reminder: '',
        reminderStr: ''
      } //初始提示语
      ,
      editor: null,
      reminderEditer: null,
      noticeModal: false,
    };
  },
  created () {
    // const editor = new wangEditor('#list-textarea')
    // const reminderEditer = new wangEditor('#wxts-textarea')
    //  // 配置 onchange 回调函数，将数据同步到 vue 中
    // editor.config.zIndex = 0
    // reminderEditer.config.zIndex = 0
    // editor.config.onchange = (newHtml) => {
    //    this.valueDate.value = newHtml
    // }
    // reminderEditer.config.onchange = (newHtml) => {
    //    this.valueDate.reminder = newHtml
    // }
    // // 默认情况下，显示所有菜单
    // editor.config.menus = [
    //     'head',
    //     'bold',
    //     'fontSize',
    //     'fontName',
    //     'italic',
    //     'underline',
    //     'strikeThrough',
    //     'indent',
    //     'lineHeight',
    //     'foreColor',
    //     'backColor',
    //     'link',
    //     'list',
    //     'justify',
    //     'quote',
    //     'emoticon',
    //     'image',
    //     'table',
    //     'code',
    //     'splitLine',
    //     'undo',
    //     'redo',
    // ]
    // reminderEditer.config.menus = [
    //     'head',
    //     'bold',
    //     'fontSize',
    //     'fontName',
    //     'italic',
    //     'underline',
    //     'strikeThrough',
    //     'indent',
    //     'lineHeight',
    //     'foreColor',
    //     'backColor',
    //     'link',
    //     'list',
    //     'justify',
    //     'quote',
    //     'emoticon',
    //     'image',
    //     'table',
    //     'code',
    //     'splitLine',
    //     'undo',
    //     'redo',
    // ]
    // editor.config.uploadImgServer = '/api/blade-platform/file/upload'
    // editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
    // editor.config.uploadImgMaxLength = 1
    // editor.config.uploadFileName = 'file'
    // editor.config.uploadImgHooks = {
    //     // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
    //     customInsert: function(insertImgFn, result) {
    //         // result 即服务端返回的接口
    //         console.log('customInsert', result)

    //         // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
    //         insertImgFn(result.data[0].oUrl)
    //     }
    // }
    // reminderEditer.config.uploadImgServer = '/api/blade-platform/file/upload'
    // reminderEditer.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
    // reminderEditer.config.uploadImgMaxLength = 1
    // reminderEditer.config.uploadFileName = 'file'
    // reminderEditer.config.uploadImgHooks = {
    //     // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
    //     customInsert: function(insertImgFn, result) {
    //         // result 即服务端返回的接口
    //         console.log('customInsert', result)

    //         // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
    //         insertImgFn(result.data[0].oUrl)
    //     }
    // }
    // this.$nextTick(()=>{
    //     editor.create()
    //     reminderEditer.create()
    // })

    // this.editor = editor
    // this.reminderEditer = reminderEditer
    // // debugger
    this.LoginAccountTipsFN();
  },
  // destroyed() {
  //     this.reminderEditer.destroy()
  //     this.editor.destroy()

  //     this.reminderEditer = null
  //     this.editor = null
  // },
  methods: {
    copy (num) {
      try {
        let url = ''
        if (num == 1) {
          url = window.location.origin + '/helpWebMobile/#/privacyPolicy/privacyPolicy'
        } else if (num == 2) {
          url = window.location.origin + '/helpWebMobile/#/privacyPolicy/userAgreement'
        }
        var input = document.createElement("input"); // 直接构建input
        input.value = url; // 设置内容
        console.log(input.value);
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        this.$message.success('复制成功')
      } catch (error) {
        console.log(error);
        this.$message.error('复制失败')
      }
      console.log(window.location);

      // alert("复制成功");
    },
    closeNotice () {
      this.valueDate.isAgainRead = 2
      this.saveLoginAccountTipsFN()
    },
    agreeNotice () {
      this.valueDate.isAgainRead = 1
      this.saveLoginAccountTipsFN()
    },
    getContent1 (html, arr) {
      this.valueDate.appUseAgreement = html
      this.valueDate.appUseAgreementStr = JSON.stringify(arr)
    },
    getContent2 (html, arr) {
      this.valueDate.content = html
      this.valueDate.contentStr = JSON.stringify(arr)
    },
    getContent3 (html, arr) {
      this.valueDate.userAgreement = html
      this.valueDate.userAgreementStr = JSON.stringify(arr)
    },
    getContent4 (html, arr) {
      this.valueDate.reminder = html
      this.valueDate.reminderStr = JSON.stringify(arr)
    },
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //重置
    ruleFormFN () {
      this.LoginAccountTipsFN();
    },
    //获取提示
    LoginAccountTipsFN () {
      this.noticeModal = false
      try {
        request({
          url: "/api/blade-platform/appconfiguration/getAppUserPrivacyConfig",
          method: "get",
          // data: params
        }).then(res => {
          const data = res.data;
          console.log("获取提示", res);
          if (data.status === 1000) {
            this.valueDate.version = data.result.version;
            this.valueDate.appUseAgreement = data.result.appUseAgreement;
            this.valueDate.appUseAgreementStr = data.result.appUseAgreementStr;
            this.valueDate.userAgreement = data.result.userAgreement;
            this.valueDate.userAgreementStr = data.result.userAgreementStr;
            this.valueDate.content = data.result.content;
            this.valueDate.contentStr = data.result.contentStr;
            this.valueDate.reminder = data.result.reminder;
            this.valueDate.reminderStr = data.result.reminderStr;
            this.$refs.wangEditor1.reset(JSON.parse(data.result.appUseAgreementStr))
            this.$refs.wangEditor2.reset(JSON.parse(data.result.contentStr))
            this.$refs.wangEditor3.reset(JSON.parse(data.result.userAgreementStr))
            this.$refs.wangEditor4.reset(JSON.parse(data.result.reminderStr))
            this.noticeModal = false
          } else {
            this.noticeModal = false
            this.$message({
              type: "error",
              message: data.msg
            });
          }

        });
      } catch (err) {
        this.noticeModal = false
        console.log(err);
      }
    },
    saveFN () {
      if (this.$refs.wangEditor1.isEmpty()) {
        this.$message.error('请输入app使用协议')
        return
      }
      if (this.$refs.wangEditor2.isEmpty()) {
        this.$message.error('请输入隐私政策')
        return
      }
      if (this.$refs.wangEditor3.isEmpty()) {
        this.$message.error('请输入用户协议')
        return
      }
      if (this.$refs.wangEditor4.isEmpty()) {
        this.$message.error('请输入温馨提示')
        return
      }
      this.noticeModal = true
      // this.$msgbox({
      //   title: '提示',
      //   // type:'warning',
      //   message: '保存后是否需要用户重新阅读并同意',
      //   showCancelButton: true,
      //   distinguishCancelAndClose: true,
      //   confirmButtonText: '需要重新阅读并同意',
      //   cancelButtonText: '仅保存',
      // }).then(action => {
      //   this.valueDate.isAgainRead = 1
      //   this.saveLoginAccountTipsFN()
      // }).catch((action) => {
      //   if (action === 'cancel') {
      //     this.valueDate.isAgainRead = 2
      //     this.saveLoginAccountTipsFN()
      //   }

      // });
    },
    // 获取文本
    getFilterText (value) {
      var temp = value.replace(/<\/?.+?>/g, "");
      var result = temp.replace(/ /g, "");//result为获取冲文字得到后的内容
      // 获取img标签
      var re = /<img[^>]+>/g;
      var ImgA = value.match(re);
      let imgLen;
      if (ImgA) {
        imgLen = ImgA.length
      }
      if (!ImgA) {
        imgLen = 0
      }
      const info = imgLen + result.length
      console.log(info, '长度')
      return info
    },
    //保存
    saveLoginAccountTipsFN () {
      // let a = this.$refs.wangEditor1.isEmpty()
      // console.log(a);
      // console.log(this.$refs.wangEditor2.isEmpty());
      // console.log(this.valueDate.appUseAgreement);
      // console.log(this.valueDate.appUseAgreementStr);

      try {
        const params = {
          appUserPrivacyVO: {
            "isAgainRead": this.valueDate.isAgainRead,//是否需要重新阅读 1需要 2不需要
            "version": this.valueDate.version,
            appUseAgreement: this.valueDate.appUseAgreement,
            appUseAgreementStr: this.valueDate.appUseAgreementStr,
            userAgreement: this.valueDate.userAgreement,
            userAgreementStr: this.valueDate.userAgreementStr,
            content: this.valueDate.content,
            contentStr: this.valueDate.contentStr,
            reminder: this.valueDate.reminder,
            reminderStr: this.valueDate.reminderStr,
          },
        };
        request({
          url: "/api/blade-platform/appconfiguration/saveAppUserPrivacyConfig",
          method: "post",
          data: params
        }).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.$message.success("保存成功")
            this.LoginAccountTipsFN();
          } else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
<style lang="scss">
.yszc {
  .w-e-scroll::-webkit-scrollbar {
    // display: none; /* Chrome Safari */

    width: 8px !important;
    height: 8px !important;
    background-color: #fff !important;
    border-radius: 20px !important;
  }
  .w-e-scroll::-webkit-scrollbar-thumb {
    // display: none; /* Chrome Safari */
    width: 8px !important;
    height: 8px !important;
    background-color: #d4d4d7 !important;
    border-radius: 4px !important;
  }
  .formOne-forms {
    .el-button {
      margin-left: 0 !important;
      margin-bottom: 5px;
    }
  }
}
.sensitiveConfiguration-text-area {
  .text-word {
    font-size: 12px;
    position: absolute;
    bottom: 0px;
    right: 20px;
    color: #909399;
  }
}
#wxts-textarea {
  .w-e-text-container {
    height: 150px !important;
  }
}
.sensitive-phon-right {
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height: calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  .phon-right-img {
    top: 70px;
    border: 2px solid #dcdee2;
    font-size: 12px;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    overflow-y: scroll;
    padding: 0 20px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
